<template>
  <div class="commonBg">
    <div class="page">
      <HeaderLayer></HeaderLayer>
      <!-- 内容 -->
      <div class="main-layer">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLayer from './header'
export default {
  components: { HeaderLayer },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.commonBg{
  width: 100%;
  height: 100%;
  background: url('~@imgs/bg.png') no-repeat;
  background-size: cover;
  position: relative;
  min-height: 800px;

  &::before,
  &::after{
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }


  &::before{
    background: url('~@imgs/bg.png') no-repeat;
    background-size: cover;
    filter: blur(3px);
  }
  &::after{
    box-shadow: 0 0 80px -12px rgba(132, 217, 255, 0.4) inset;
    z-index: 99;
  }
}
.page {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: relative;

  .main-layer {
    width: 100%;
    height: calc(100% - var(--headerH));
    overflow: auto;
    // overflow: hidden;
    // padding: 5px 0px 10px;
    box-sizing: border-box;
  }
}
</style>
